import { makeStyles } from '@forgeglobal/design-framework';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    maxWidth: 880,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: 976,
      padding: theme.spacing(0, 6),
    },
  },
  title: {},
  accountNumber: {
    marginBottom: theme.spacing(6),
    color: theme.palette.grey[550],
  },
  tableTitle: {
    marginBottom: theme.spacing(1),
  },
  subTitle: {
    marginBottom: theme.spacing(2),
  },
  contingentTable: {
    marginTop: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(4),
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(6),
    },
  },
  primaryButton: {
    marginLeft: theme.spacing(2),
  },
  addButton: {
    marginBottom: theme.spacing(2),
  },
  radiogroup: {
    display: 'flex',
    flexDirection: 'row',
  },
  dropdown: {
    '& > div:first-child': {
      marginTop: 0,
    },
  },
  actions: {
    display: 'flex',
  },
  notifications: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    paddingTop: '16px',
  },
  dialogContent: {
    paddingLeft: '32px',
    paddingRight: '32px',
    paddingTop: '32px',
  },
  dialogActions: {
    justifyContent: 'flex-end',
    padding: '24px',
  },
}));

export default useStyles;
